import { SHA256 } from "crypto-js";

const encryptHash = (value) => {
    let ciphertext = SHA256(value+"", process.env.REACT_APP_GENERAL_HASH);
    return ciphertext.toString();
};

export default encryptHash;